/**
 * `webreports.WEBObjects.ObjectHref` is a ui-router state of the v1 portal, and
 * both the menu and the landing page have to turn it into a URL on this origin.
 */

/**
 * The legacy portal is served from this same origin at `/legacy/` and shares the
 * session cookie, so its pages are a path prefix away — no second login, no
 * cross-origin.
 */
export const LEGACY_BASE = (import.meta.env.VITE_LEGACY_BASE ?? '/legacy').replace(/\/$/, '');

/**
 * A state can carry parameters as a JavaScript object literal:
 * `/dictionaries({ID:'customers'})` — the v1 router took them as state params,
 * the rewritten routes take them as a path segment.
 */
export function legacyUrl(href: string): string {
  const open = href.indexOf('(');
  if (open < 0) return `${LEGACY_BASE}${href.trim()}`;

  const body = href.slice(open + 1, href.lastIndexOf(')'));
  const id = /ID\s*:\s*'([^']*)'/.exec(body)?.[1];
  const path = href.slice(0, open).trim();
  return `${LEGACY_BASE}${path}${id ? `/${encodeURIComponent(id)}` : ''}`;
}
